
import  { dashboardService } from "@/services/dashboard.service";

const state = {
    loading: false,
    overlay: false,
    dashboard:  {
        "totalagen": 0,
        "agenaktiftoday": 0,
        "topupchannel": 0,
        "irsmarketbalance": 0,
        "tokensms": 0
    }
}

const actions = {
    getDashboard({ commit }) {
        commit('setloading', true);
        dashboardService.getDashboard().then(data => {
            commit('addDashboardData', data);
        }, error => {
            console.log(error);
        });
    },
}

const mutations = {
    setloading(state, data) {
        state.loading = data;
        state.overlay = data;
    },
    addDashboardData(state, dash) {
        state.dashboard = dash.data;
        state.loading = false;
    },
}


export const Dashboard = {
    namespaced: true,
    state,
    actions,
    mutations
};
